import * as React from 'react';
import { config } from '../../../config';
import { composer } from '../../../component-decorators/composer';
import { Box, Button, Heading, Text } from 'wix-style-react';
export var dtoToShareAppProps = function (res, shareId) {
    var appInstallParams = {
        appDefId: res.baseInfo.id,
        isPremiumApp: res.baseInfo.pricing && res.baseInfo.pricing.isRequiredWixPremium,
        openMethod: res.baseInfo.openConsentIn,
        shareId: shareId,
        version: 'latest'
    };
    return {
        appName: res.baseInfo && res.baseInfo.name,
        ctaClickHandler: function () { return config.installApp(appInstallParams); },
    };
};
export var ShareApp = composer()
    .withTranslation()
    .compose(function (_a) {
    var appName = _a.appName, ctaClickHandler = _a.ctaClickHandler, t = _a.t;
    return (React.createElement("div", { style: {
            display: 'flex',
            flexDirection: 'column',
            width: '100vw',
            height: '100vh',
        }, "data-testid": "share-app" },
        React.createElement(Box, { padding: "90px 0 100px 90px" },
            React.createElement("img", { src: config.marketplaceStaticsUrl + "assets/images/wixlogo.svg", alt: "wix" })),
        React.createElement(Box, { direction: "vertical", align: "center" },
            React.createElement(Heading, { appearance: "H2" }, t('share-app.title')),
            React.createElement(Box, { marginBottom: "12px" },
                React.createElement(Heading, { appearance: "H2", dataHook: "app-name" }, appName)),
            React.createElement(Box, { marginBottom: "36px" },
                React.createElement(Text, null, t('share-app.sub-title'))),
            React.createElement(Button, { size: "large", onClick: ctaClickHandler, dataHook: "cta-button" }, t('share-app.add-to-site')))));
});
//# sourceMappingURL=share-app.js.map